import httpManager from "@/app/shared/utils/httpManager";

export default async function (portfolioId) {
  await httpManager.delete(`/portfolios/${portfolioId}/`);
}
